import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import { templateKeys } from './queryKeys';
import useQueryRequestParams from '../../../hooks/useQueryRequestParams';
import markUrl from './markUrl';
const useMarkTemplate = (id, enabled = true) => {
    const additional = useQueryRequestParams();
    return useQuery({
        queryKey: templateKeys.row(id ?? 0),
        queryFn: () => axios.get(markUrl('mark-templates/detail/'), {
            ...additional,
            params: { id }
        }),
        enabled: id != null && enabled,
        staleTime: 30_000
    });
};
export default useMarkTemplate;
